import initMinigallery from './packages/package-minigallery';
import { initAccordions } from './utils';

window.com.parkside.fixations = function () {};

window.com.parkside.fixations.init = function () {
  initAccordions();
  initMinigallery();
};
